function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeleteItem = function SvgDeleteItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "#37798e",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M1 13 13 1M1 1l12 12",
    transform: "scale(.71429)"
  }));
};
export { SvgDeleteItem as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMHB4IiBoZWlnaHQ9IjEwcHgiIHZpZXdCb3g9IjAgMCAxMCAxMCIgdmVyc2lvbj0iMS4xIj4KPGcgaWQ9InN1cmZhY2UxIj4KPHBhdGggc3R5bGU9ImZpbGw6bm9uZTtzdHJva2Utd2lkdGg6MTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46bWl0ZXI7c3Ryb2tlOnJnYigyMS41Njg2MjclLDQ3LjQ1MDk4JSw1NS42ODYyNzUlKTtzdHJva2Utb3BhY2l0eToxO3N0cm9rZS1taXRlcmxpbWl0OjQ7IiBkPSJNIDEuMDAwNzgxIDEyLjk5OTIxOSBMIDEyLjk5OTIxOSAxLjAwMDc4MSAiIHRyYW5zZm9ybT0ibWF0cml4KDAuNzE0Mjg2LDAsMCwwLjcxNDI4NiwwLDApIi8+CjxwYXRoIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLXdpZHRoOjE7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOm1pdGVyO3N0cm9rZTpyZ2IoMjEuNTY4NjI3JSw0Ny40NTA5OCUsNTUuNjg2Mjc1JSk7c3Ryb2tlLW9wYWNpdHk6MTtzdHJva2UtbWl0ZXJsaW1pdDo0OyIgZD0iTSAxLjAwMDc4MSAxLjAwMDc4MSBMIDEyLjk5OTIxOSAxMi45OTkyMTkgIiB0cmFuc2Zvcm09Im1hdHJpeCgwLjcxNDI4NiwwLDAsMC43MTQyODYsMCwwKSIvPgo8L2c+Cjwvc3ZnPgo=";